export default function (state, val) {
    let filter = state.filters.filter(i => {
        return i.id === val.id;
    })[0];
    for (let k in val) {
        switch (k) {
            default:
                if (typeof filter[k] !== 'undefined') filter[k] = val[k];
        }
    }
}